import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { Provider } from "./components/ui/provider"
import { I18nProvider } from "./i18n"

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider>
      <I18nProvider>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </I18nProvider>
    </Provider>
  </StrictMode>,
)
